module.exports = __webpack_public_path__ + "static/transclean-00-hero-0efb3a60b0081792aabb202eebb4e58e.jpg";